export interface FireworkVideoMeta {
  videoId?: string;
  contentTitle?: string;
  liveStreamStatus?: string;
}

export interface ResolveApiVideoMetaParams {
  eventDetail?: unknown;
  fallbackVideoId?: string;
  videoMetaMap?: Record<string, FireworkVideoMeta>;
}

function toRecord(value?: unknown): Record<string, unknown> {
  return (value || {}) as Record<string, unknown>;
}

export function resolveLivestreamStatus(eventDetail?: unknown): string {
  const detail = toRecord(eventDetail);
  const video = toRecord(detail.video);

  const raw =
    (typeof video.status === "string" && video.status.trim()) ||
    (typeof video.live_stream_status === "string" && video.live_stream_status.trim()) ||
    (typeof detail.status === "string" && detail.status.trim()) ||
    (typeof detail.live_stream_status === "string" && detail.live_stream_status.trim()) ||
    "";

  const normalized = raw.toLowerCase();
  if (normalized === "live" || normalized === "replay" || normalized === "idle") {
    return normalized;
  }
  if (normalized === "active") {
    return "live";
  }
  if (normalized) {
    return "idle";
  }
  return "idle";
}

export function resolveApiVideoMeta({
  eventDetail,
  fallbackVideoId,
  videoMetaMap,
}: ResolveApiVideoMetaParams): FireworkVideoMeta {
  const map =
    videoMetaMap ||
    (typeof window !== "undefined"
      ? ((window as Window & { __fwVideoMetaMap?: Record<string, FireworkVideoMeta> })
          .__fwVideoMetaMap ?? {})
      : {});

  const detail = toRecord(eventDetail);
  const video = toRecord(detail.video);
  const candidateIds = [
    typeof video.encoded_id === "string" ? video.encoded_id.trim() : "",
    typeof video.id === "string" ? video.id.trim() : "",
    typeof detail.videoId === "string" ? detail.videoId.trim() : "",
    typeof detail.encoded_id === "string" ? detail.encoded_id.trim() : "",
    typeof detail.id === "string" ? detail.id.trim() : "",
    fallbackVideoId || "",
  ].filter(Boolean);

  for (const candidateId of candidateIds) {
    const found = map[candidateId];
    if (found) {
      return found;
    }
  }

  return {};
}
